import { useState } from 'preact/hooks';
import { Icon } from '../Icon';

export const CHAT_MAX = 140;

/** Trim, cap and send. Returns true if a command was dispatched. */
export function submitChat(bridge, raw) {
    const text = raw.trim().slice(0, CHAT_MAX);
    if (!text) return false;
    bridge.say(text);
    return true;
}

export function ChatBar({ bridge }) {
    const [text, setText] = useState('');
    const send = (e) => {
        e.preventDefault();
        if (submitChat(bridge, text)) setText('');
    };
    return (<form class="chat-bar" onSubmit={send} onPointerDown={(e) => e.stopPropagation()}>
      <input class="chat-input" type="text" maxLength={CHAT_MAX} value={text} placeholder="Talk to people nearby" aria-label="Chat message" autocomplete="off" onInput={(e) => setText(e.currentTarget.value)}/>
      <button type="submit" class="chip chat-send" aria-label="Send"><Icon name="arrow-up02"/></button>
    </form>);
}
